var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRefreshCw = function SvgRefreshCw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "refresh-cw_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 4v6h-6M1 20v-6h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9.001 9.001 0 0 0 20.49 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgRefreshCw as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMjMgNFYxMEgxNyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTEgMjBWMTRINyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTMuNTEgOC45OTk5NUM0LjAxNzE3IDcuNTY2NzQgNC44NzkxMyA2LjI4NTM2IDYuMDE1NDcgNS4yNzUzN0M3LjE1MTggNC4yNjUzOSA4LjUyNTQ3IDMuNTU5NzIgMTAuMDA4MyAzLjIyNDIxQzExLjQ5MTEgMi44ODg3IDEzLjAzNDggMi45MzQyOSAxNC40OTUyIDMuMzU2NzNDMTUuOTU1NiAzLjc3OTE2IDE3LjI4NTMgNC41NjQ2NyAxOC4zNiA1LjYzOTk1TDIzIDkuOTk5OTVNMSAxNEw1LjY0IDE4LjM2QzYuNzE0NzUgMTkuNDM1MiA4LjA0NDM3IDIwLjIyMDcgOS41MDQ4MSAyMC42NDMyQzEwLjk2NTIgMjEuMDY1NiAxMi41MDg5IDIxLjExMTIgMTMuOTkxNyAyMC43NzU3QzE1LjQ3NDUgMjAuNDQwMiAxNi44NDgyIDE5LjczNDUgMTcuOTg0NSAxOC43MjQ1QzE5LjEyMDkgMTcuNzE0NSAxOS45ODI4IDE2LjQzMzIgMjAuNDkgMTUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";